import { render, staticRenderFns } from "./ContractManagement.vue?vue&type=template&id=16956b64"
import script from "./ContractManagement.vue?vue&type=script&lang=js"
export * from "./ContractManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports